export const pallete = {
  black: '#000000',
  white: '#ffffff',
  red: '#EB0000',
  green: '#00CA1B',
  blue: '#0059FF',
  grey: '#E0E0E0',
  pastel: {
    black: '#2d2d2d',
    white: '#f0f0f0',
    red: '#F44336',
    green: '#50FA7B',
    blue: '#8BE9FD',
    pink: '#FF79C6',
    orange: '#FFB86C',
    lightBlue: '#D9F0FF',
    purple: '#966EED',
  },
}
